import React from 'react';
import defaultPropTypes from '../utils/prop-types';

var SearchFilterButton = function SearchFilterButton(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.settings.Filters.length > 0 && /*#__PURE__*/React.createElement("button", {
    className: "search-filter-button",
    onClick: function onClick(e) {
      props.onOpenFilterList(e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-icon"
  }), props.settings.dictionary.filterListButton));
};

export default SearchFilterButton;
SearchFilterButton.propTypes = {
  onOpenFilterList: defaultPropTypes.func,
  settings: defaultPropTypes.settings
};
SearchFilterButton.defaultProps = {
  onOpenFilterList: defaultPropTypes.defaultOnOpenFilterList,
  settings: defaultPropTypes.defaultSettings
};